import {Component, Vue} from 'vue-property-decorator'
import {getAccountsReceivableDetailStatisticalReport} from "@/api/financial-center";
import {delNullProperty} from "@/utils";
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import {formatDate} from "@/utils/timeFilter";
import {getDeparmentList} from "@/api/common";


@Component({
    components: {
        MoreUsersFilter
    }
})
export default class ARSummaryReport extends Vue {
    loading = false
    tableData: any = []
    filterData = {
        marketCooperationName: '',
        directorUserIdList: [],
        souCourseSchoolBegin: '',
        createdAt: '',
    }
    total = 0
    timer = null
    timeBeginDate: Date[] | null = null
    timeCreateDate: Date[] | null = null
    page = 1   // 当前页码
    pageSize = 20     // 每页条数
    hasNextPage = true  // 是否有下一页
    deparmentList: any = [] // 部门列表
    checkRangeDepartmentList: Array<number> = [] // 适用范围内选中的部门 id
    departmentIdList = []
    checkDeparmentInfo: any = [] // 选中的部门信息
    accessibleList: any = []
    directorUserName: string | null = null


    created() {
        if (this.$route.query.timeBeginDate)
            this.timeBeginDate = (this.$route.query.timeBeginDate as any).split('&')
        if (this.$route.query.timeCreateDate)
            this.timeCreateDate = (this.$route.query.timeCreateDate as any).split('&')
        this.filterData.directorUserIdList = [this.$route.query.directorUserId]
        this.directorUserName = this.$route.query.directorUserName as string
        this.getTableData()
    }

    async mounted() {
        await this.getDeparment();
    }

    async getTableData() {
        this.loading = true
        const obj = {
            marketCooperationName: this.filterData.marketCooperationName,
            departmentIdList: this.departmentIdList,
            directorUserIdList: this.filterData.directorUserIdList,
            souCourseSchoolBegin: this.changeTime(this.timeBeginDate as Date[]),
            createdAt: this.changeTime(this.timeCreateDate as Date[]),
            limit: this.pageSize,
            page: this.page
        }
        await getAccountsReceivableDetailStatisticalReport(delNullProperty(obj)).then((data: any) => {
            this.tableData = data.financeOrderList
            this.total = data.allNum
            setTimeout(() => {
                this.loading = false
            }, 2000);
            this.loading = false
        }).catch(() => {
            this.tableData = []
            this.loading = false
        })

    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.pageSize = limit
        this.getTableData()
    }

    changeDirectorUserIdList(e) {
        this.filterData.directorUserIdList = e.id
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = 1
            this.getTableData()
        }, 1000)
    }


    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }

    async getDeparment() {
        const data: any = await getDeparmentList()
        this.deparmentList = data
    }

    chooseDepartment(checkedKeys, checkedData) {

        // 取消勾选
        const [accessibleList, getCheckedKeys] = [this.accessibleList, (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        // 循环删除this.accessibleList中的项
        for (const i in accessibleList) {
            if (accessibleList[i].id == checkedKeys.id) {
                this.accessibleList.splice(i, 1);
                return;
            }
        }
        // 添加勾选
        const [arr, newArr] = [[], (this.$refs.tree as HTMLFormElement).getCheckedKeys()];
        arr.push(checkedKeys);

        function dealData(arr, newArr) {
            for (const i in arr) {
                newArr.push(arr[i].id);
                dealData(arr[i].children, newArr);
            }
        }

        // newArr代表获取出来的当前节点以及其下的所有子节点的id
        dealData(arr, newArr);
        (this.$refs.tree as HTMLFormElement).setCheckedKeys(newArr);
        // newJsonArr代表所有选中的节点
        const newJsonArr = (this.$refs.tree as HTMLFormElement).getCheckedNodes();
        this.accessibleList = newJsonArr;
        this.checkDeparmentInfo = []

        newJsonArr.map(item => {
            this.checkDeparmentInfo.push({
                department: {
                    name: item.name,
                    detail: null,
                    id: item.id
                },
                departmentId: item.id
            })
        })

    }

    treeChange(item: any, itembol: boolean) {
        if (itembol) {
            const res = (this.$refs.tree as HTMLFormElement).getCheckedNodes()
            const arrDeptId = []
            res.forEach((item) => {
                arrDeptId.push({
                    department: {
                        name: item.name,
                        detail: null,
                        id: item.id
                    },
                    departmentId: item.id
                })
            })
            this.checkDeparmentInfo = arrDeptId
        } else {

            this.checkDeparmentInfo.map((t: any, i: number) => {
                if (t.departmentId === item.id) {
                    this.checkDeparmentInfo.splice(i, 1)
                }
            });
        }

        this.checkRangeDepartmentList = []
        this.checkDeparmentInfo.forEach((item) => {
            this.checkRangeDepartmentList.push(item.departmentId)
        })
        this.departmentIdList = this.checkRangeDepartmentList

    }


    clickDirectorUserName(row: any) {
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ARSummaryReport')
        const time = setInterval(() => {
            if (win.closed) {
                this.getTableData()
                clearInterval(time)
            }
        }, 500)
    }

}
